import type { SVGProps } from 'react';

export const TrimIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M5.93277 7.48913L10.5594 10.6198C11.0181 10.9305 11.2901 11.4465 11.2901 11.9998C11.2901 12.5531 11.0181 13.0691 10.5594 13.3798L5.93411 16.5104C5.65144 16.7011 5.32611 16.7971 4.99944 16.7971C4.73278 16.7971 4.46478 16.7331 4.21811 16.6024C3.67144 16.3131 3.33278 15.7478 3.33278 15.1304V8.86913C3.33278 8.2518 3.67144 7.68647 4.21811 7.39713C4.76478 7.1078 5.42211 7.14247 5.93277 7.48913ZM18.0647 7.48913C18.5794 7.14247 19.2354 7.1078 19.7807 7.39713C20.3274 7.68647 20.6661 8.2518 20.6661 8.86913V15.1331C20.6661 15.7504 20.3274 16.3158 19.7807 16.6051C19.5341 16.7344 19.2661 16.7998 18.9994 16.7998C18.6727 16.7998 18.3474 16.7038 18.0661 16.5131L13.4394 13.3811C12.9808 13.0705 12.7088 12.5545 12.7088 12.0011C12.7088 11.4478 12.9808 10.9318 13.4394 10.6211L18.0647 7.48913Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
